import request from '@/utils/request'

// 항목조회
export function getSafetyInspectionDivList(params, isProgress) {
  return request({
    url: `/api/getSafetyInspectionDivList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}

// 항목 아이템 조회
export function getSafetyInspectionItemList(params, isProgress) {
  return request({
    url: `/api/getSafetyInspectionItemList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}

// 일일안전점검 항목 조회
export function getSafetyInspection(params, isProgress) {
  return request({
    url: `/api/getSafetyInspection`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}

// 항목 저장
export function saveSafetyInspectionItem(params, isProgress) {
  return request({
    url: `/api/saveSafetyInspectionItem`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 일일안전점검 체크리스트 저장
export function saveSafetyInspection(params, isProgress) {
  return request({
    url: `/api/saveSafetyInspection`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
export function deleteSafetyInspection(params, isProgress) {
  return request({
    url: `/api/deleteSafetyInspection`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}

export function saveSafetyInspectionItemList(params, isProgress) {
  return request({
    url: `/api/saveSafetyInspectionItemList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 항목 삭제
export function deleteSafetyInspectionItem(params, isProgress) {
  return request({
    url: `/api/deleteSafetyInspectionItem`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
//항목 예하 목록 삭제
export function deleteSafetyInspectionItemList(params, isProgress) {
  return request({
    url: `/api/deleteSafetyInspectionItemList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}

// 레포트
export function getRptSafetyInspection(params){
  // html 이미지 출력 문제로 보류
  // let responseType = params.type !== "html" ? "blob" : "stream"
  let responseType = "blob"
  return request({
    url:'/api/getRptSafetyInspection',
    method:'POST',
    meta:{apiVersion:'1.0.0'},
    headers:{ 'Content-Type': 'application/json;charset=utf8' },
    data : params,
    responseType: responseType
  })
}

// 실시 한 날짜리스트 조회 (일일)
export function getDailyImplementaionDateList (params, isProgress) {
  return request({
    url: `/api/getDailyImplementaionDateList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
} 

// 실시 한 날짜리스트 조회 (순회)
export function getCircuitImplementaionDateList (params, isProgress) {
  return request({
    url: `/api/getCircuitImplementaionDateList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
} 

// 순회안전점검 API
export function getCircuitSafetyInspection (params, isProgress) {
  return request({
    url: `/api/getCircuitSafetyInspection`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
} 

export function saveCircuitSafetyInspection (params, isProgress) {
  return request({
    url: `/api/saveCircuitSafetyInspection`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
} 

export function deleteCircuitSafetyInspection (params, isProgress) {
  return request({
    url: `/api/deleteCircuitSafetyInspection`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
} 

export function deleteCircuitTaskSafetyInspection(params, isProgress) {
  return request({
    url: `/api/deleteCircuitTaskSafetyInspection`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
} 

// 레포트
export function getRptCircuitSafetyInspection(params){
  // html 이미지 출력 문제로 보류
  // let responseType = params.type !== "html" ? "blob" : "stream"
  let responseType = "blob"
  return request({
    url:'/api/getRptCircuitSafetyInspection',
    method:'POST',
    meta:{apiVersion:'1.0.0'},
    headers:{ 'Content-Type': 'application/json;charset=utf8' },
    data : params,
    responseType: responseType
  })
}
